export default {
      id: "icon-pause-usage",
      viewBox: "0 0 300.003 300.003",
      url: "/" + "assets/sprite.svg#icon-pause",
      toString: function () {
        return this.url;
      }
    }